module.exports = __webpack_public_path__ + "static/img/webapps-03.b6171949.png";